
import BotAgentCreateModal from '@/components/bot/BotAgentCreateModal.vue';
import AppColorPicker from '@/components/ui/AppColorPicker.vue';
import AppSelect from '@/components/ui/AppSelect.vue';
import { AuthMixin } from '@/mixins/AuthMixin';
import { WeddingEventSettings } from '@/types';
import QRCode from 'qrcode';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bot-wedding-event-form',
  components: { AppColorPicker, AppSelect, BotAgentCreateModal },
})
export default class BotWeddingEventForm extends mixins(AuthMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: WeddingEventSettings;

  @Prop({ required: false, type: Boolean, default: false })
  readonly create!: boolean;

  qrCodeDataUrl = '';
  showCreateAgentModal = false;

  templateOptions = [
    { value: 'classic', label: 'Classic' },
    { value: 'celebration', label: 'Celebration' },
  ];

  onInput(key: string, value: any) {
    const updatedValue: WeddingEventSettings = JSON.parse(JSON.stringify(this.value));

    if (key.includes('.')) {
      const keys = key.split('.');
      let current: any = updatedValue;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!(keys[i] in current)) {
          current[keys[i]] = {};
        }
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
    } else {
      (updatedValue as any)[key] = value;
    }

    this.$emit('input', updatedValue);
  }

  /** Absolute public event URL so the QR code matches "Open public page" on phones. */
  get publicUrl() {
    return `${window.location.origin}/s/${this.value.slug}`;
  }

  async generateQrCode() {
    try {
      this.qrCodeDataUrl = await QRCode.toDataURL(this.publicUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  }

  async mounted() {
    await this.generateQrCode();
  }

  @Watch('publicUrl')
  onPublicUrlChange(): void {
    this.generateQrCode();
  }

  generateSlugFromName(name: string) {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  @Watch('value.name')
  onNameChange(newName: string): void {
    this.onInput('slug', this.generateSlugFromName(newName));
  }
}
